import { useEffect } from 'react';

import useLeafletMap from './useLeafletMap';

const useLeafletMapEvent = (eventName, handler) => {
  const map = useLeafletMap();

  useEffect(
    () => {
      if ((!map) || (!handler)) return undefined;
      map.on(eventName, handler);
      return () => {
        map.off(eventName, handler);
      };
    },
    [map, eventName, handler],
  );
};

export default useLeafletMapEvent;
